import * as React from "react"
import { Flex, FlexProps } from "rebass"
import theme from "BookingSystem/theme"
import styled from "styled-components"
import { DailyQuickView } from "./DailyQuickView"
import { observer } from "mobx-react"
import DayPickerInputComp from "./DayPickerInputComp"

@observer
export class DailyQuickViewComp extends React.Component<{
  model: DailyQuickView
}> {
  componentDidMount() {
    this.props.model.componentDidMount()
  }

  componentWillUnmount() {
    this.props.model.componentWillUnMount()
  }
  render() {
    const { model } = this.props

    const Heading = styled(Flex)`
      justify-content: center;
      align-items: center;
      color: ${theme.colors.text};
    `

    const HeadingLabel = styled<FlexProps>(Flex)`
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      height: 50%;
      color: ${theme.colors.white};
      font-weight: bold;
    `
    const colorForSessionType = function(sessions: any): string {
      const name =
        sessions[0] && sessions[0].sessionType.object.name.toLowerCase()
      switch (name) {
        case "jump mo":
          return theme.colors.activityButton1
        case "climb mo":
          return theme.colors.activityButton2
        case "play mo":
          return theme.colors.activityButton3
        case "observe mo":
          return theme.colors.activityButton4
      }
      return theme.colors.activityButton1
    }

    return (
      <Flex
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        width={1}
        style={{
          height: "100vh",
          background: theme.colors.background,
          overflowY: "scroll"
        }}
      >
        <Flex
          flexDirection="column"
          alignItems="center"
          justifyContent="flex-start"
          bg={theme.colors.interactiveBackground}
          width={[1, 0.9]}
          style={{
            height: window.innerWidth > 450 ? "99%" : "100%"
          }}
        >
          <Flex
            flexDirection={["row"]}
            alignItems="center"
            justifyContent="space-evenly"
            width={1}
            style={{ height: "10%" }}
            className="header"
          >
            <Heading
              width={[0.25, 0.4]}
              flexDirection="column"
              justifyContent="space-between"
              fontSize={24}
            >
              {model.isToday
                ? "Date selected: TODAY"
                : `Date selected: ${model.currentDate.format("MMM DD, YYYY")}`}
              <DayPickerInputComp model={model} />
            </Heading>
            {model.sessions.map((session, i) => (
              <Heading width={[0.25, 0.2]} style={{ height: "100%" }} key={i}>
                <HeadingLabel
                  className={session[0] && session[0].sessionType.object.name}
                  px={2}
                  m={[2, 0]}
                  width={[100, 150]}
                  fontSize={[14, 18]}
                  style={{
                    background: colorForSessionType(session)
                  }}
                >
                  {session[0] && session[0].sessionType.object.name}
                </HeadingLabel>
              </Heading>
            ))}
          </Flex>
          <Flex
            color={theme.colors.white}
            width={[1, 0.95]}
            mb={2}
            style={{
              borderBottom: "solid 1px white",
              height: 4
            }}
          />
          <Flex width={1} style={{ overflowY: "scroll" }}>
            <Flex width={[0.25, 0.4]} className="time" flexDirection="column">
              {model.sessionTimes &&
                model.sessionTimes.map((v, i) => (
                  <Flex
                    key={i}
                    bg={
                      i % 2 === 0
                        ? "#1c2323"
                        : theme.colors.interactiveBackground
                    }
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    color={"white"}
                    style={{ height: 33, maxHeight: 33, minHeight: 33 }}
                  >
                    {v}
                  </Flex>
                ))}
            </Flex>
            {model.sessions.map((sessions, i) => (
              <Flex
                key={i}
                width={[0.25, 0.2]}
                className={sessions[0] && sessions[0].sessionType.object.name}
                flexDirection="column"
              >
                {sessions.map((v, i) => (
                  <Flex
                    key={i}
                    bg={
                      i % 2 === 0
                        ? "#1c2323"
                        : theme.colors.interactiveBackground
                    }
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    color={
                      v.numberBooked >= v.capacity * 0.9
                        ? "red"
                        : v.numberBooked < 1
                        ? "hsla(0,0%,100%, 0.3)"
                        : "white"
                    }
                    style={{ height: 33, maxHeight: 33, minHeight: 33 }}
                    onClick={() => {
                      const newCapacity = prompt(
                        "Please enter the new capacity for this session.",
                        String(v.capacity)
                      )
                      if (newCapacity != null) {
                        model.updateCapacity(v, Number.parseInt(newCapacity))
                      }
                    }}
                  >
                    <Flex flexDirection="row">
                      <Flex
                        justifyContent="center"
                        alignItems="center"
                        fontSize={["1rem", "1.5rem"]}
                      >
                        {v.numberBooked}
                      </Flex>
                      <Flex justifyContent="center" alignItems="center" mx={2}>
                        /
                      </Flex>
                      <Flex
                        justifyContent="center"
                        alignItems="center"
                        fontSize={["0.5rem", "0.75rem"]}
                      >
                        {v.capacity}
                      </Flex>
                    </Flex>
                  </Flex>
                ))}
              </Flex>
            ))}
          </Flex>
        </Flex>
      </Flex>
    )
  }
}
